import {UI} from "stem-core/ui/UIBase";
import {registerStyle, styleRule} from "stem-core/ui/Style";
import {StyleSheet} from "stem-core/ui/Style";
import {Card} from "../../ui/Card.jsx";
import {CardItems} from "../../ui/CardItems.jsx";
import {AddCreditModal} from "../AddCreditModal.jsx";
import {Money} from "../../../../stem-core/localization/Money.js";
import {BlinkButton} from "../../../../core/ui/Button.jsx";
import {autoredraw} from "../../../../stem-core/decorators/AutoRedraw";
import {Wallet} from "../../../../client/state/WalletStore.js";

class UserWalletStyle extends StyleSheet {
    @styleRule
    addCreditButton = {
        marginTop: 20,
        fontWeight: "normal",
    };

}

@registerStyle(UserWalletStyle)
@autoredraw(Wallet)
export class UserWallet extends UI.Element {

    onAddCreditClick() {
         const {user} = this.options;
        // TODO - can have multiple
        const wallet = user.getDefaultWallet();

        AddCreditModal.show({user, wallet});
    }

    render() {
        const {user} = this.options;
        // TODO - can have multiple
        const wallet = user.getDefaultWallet();

        return (
            <Card title="Wallet">
                <CardItems
                    items={[
                        ["Id", wallet.id],
                        ["Currency", wallet.getCurrency().isoCode.toUpperCase()],
                        ["Balance", Money.format(wallet.balance, wallet.getCurrency())],
                    ]}
                />
                <BlinkButton className={this.styleSheet.addCreditButton}
                             onClick={() => this.onAddCreditClick()}
                             label="Add Credit">
                </BlinkButton>
            </Card>
        );
    }
}
